import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";

import ReviewPage from "./ReviewPage";

function HsgServices() {
  return (
    <>
      <div id="hsg-services"></div>
      <Header />
      <section className=" page p-0 m-0 gap-0">
        <div>
          {/* Header */}
          <div className="bg-light py-0 text-center">
            <h1
              className="contact-bg pt-0 text-light  text-uppercase  text-center  fw-bold col-md-12 col-lg-12 col-sm-12 "
              style={{
                fontSize: "2.5rem",
                letterSpacing: "2.5px",
                borderBottom: "7px solid gold",
                borderRadius: "5px",
                display: "inline-block",
                paddingBottom: "5px",
              }}
            >
              Hysterosalpingogram (HSG)
            </h1>
          </div>

          {/* Main Section / part 1*/}
          <div className="container my-5">
            <div className="row align-items-center g-4">
              {/* Left Content */}
              <div className="col-lg-6">
                <h2 className="fw-bold text-primary-emphasis ">
                  Get an HSG at Rapid Lab Diagnostics and Experience the
                  Difference in Care and Quality
                </h2>

                <div
                  className="my-3"
                  style={{
                    width: "200px",
                    height: "5px",
                    backgroundColor: "gold",
                    borderRadius: "5px",
                  }}
                ></div>

                <p className="text-primary-emphasis">
                  HSG (Hysterosalpingogram) is a specialized imaging procedure
                  used to evaluate the uterus and fallopian tubes. It involves
                  the injection of a contrast dye followed by X-ray images to
                  visualize the reproductive organs and detect any blockages or
                  abnormalities. If you have been recommended to undergo an HSG,
                  Rapid Lab Diagnostics is here to provide you with exceptional
                  care and accurate results. Our state-of-the-art imaging
                  technology and experienced healthcare professionals ensure
                  that you receive the highest quality service in a comfortable
                  and supportive environment. During the HSG procedure, our
                  skilled technicians will guide you through the process,
                  ensuring your comfort and safety throughout. The detailed
                  images obtained from the HSG will assist your healthcare
                  provider in diagnosing any issues with your reproductive
                  system and developing an appropriate treatment plan. Contact
                  us today to schedule your HSG appointment and take a step
                  towards understanding your reproductive health better.
                </p>

                <p className="text-primary-emphasis">
                  {" "}
                  if you have any questions or concerns about the HSG procedure,
                  our team is here to assist you every step of the way.
                </p>
              </div>
              {/* Right Images */}
              <div className="col-lg-6 text-center pt-3">
                <img
                  src="images/assets/hsg2.jpeg"
                  alt="hsg"
                  loading="lazy"
                  className="img-fluid rounded mb-3"
                  style={{
                    maxHeight: "400px",
                    objectFit: "cover",
                    width: "100%",
                  }}
                />

                {/* Thumbnails */}
                <div className="d-flex justify-content-center gap-2">
                  <img
                    src="https://rgshealthcare.com/wp-content/uploads/2024/05/1200px_rgsHealthCare_AdobeStock_405836547-768x512.jpg"
                    alt="lab1"
                    loading="lazy"
                    className="rounded"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />
                  <img
                    src="images/assets/hsg1.png"
                    alt="lab2"
                    loading="lazy"
                    className="rounded"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />
                  <img
                    src="images/assets/ultraSound.jpeg"
                    alt="lab3"
                    loading="lazy"
                    className="rounded"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </div>
            {/* put  CARD HERE */}
            <div
              className="card mb-3 mt-3 pt-md-2 shadow-sm rounded"
              style={{ maxWidth: "600px", borderTop: "4px solid #FFD700" }}
            >
              <div className="row g-0">
                <div className="col-md-12">
                  <div className="card-body">
                    <h5 className="card-title text-primary-emphasis fw-semibold">
                      How it Works
                    </h5>
                    <p className="card-text col-12">
                      During the HSG procedure, a contrast dye is gently
                      injected into the uterus through the cervix. This dye
                      helps to highlight the reproductive organs on X-ray
                      images. As the dye fills the uterus and fallopian tubes, a
                      series of X-ray images are taken to visualize the shape
                      and structure of these organs. The images can reveal any
                      blockages, abnormalities, or issues that may be affecting
                      fertility or causing other reproductive health concerns.
                      The entire procedure is typically quick and may cause some
                      mild discomfort, but our experienced healthcare
                      professionals will ensure your comfort and safety
                      throughout the process. If you would like to know more
                      about your upcoming exam or procedure, please click below
                      for a more detailed description.
                    </p>
                    <p className="card-text col-12"></p>
                  </div>
                </div>
              </div>
            </div>
            {/* Banner */}
            <div className="container my-5">
              <div
                className="d-flex flex-column flex-md-row align-items-center justify-content-between p-5"
                style={{
                  backgroundColor: "#0f5b7f",
                  borderRadius: "12px",
                }}
              >
                {/* Left Text */}
                <h2
                  className="text-white mb-4 mb-md-0"
                  style={{
                    fontSize: "32px",
                    fontWeight: "500",
                    maxWidth: "700px",
                    lineHeight: "1.4",
                  }}
                >
                  Visit Us for Your Laboratory Needs and Experience the
                  Difference in Care and Quality
                </h2>

                {/* Right Button */}
                <Link
                  className="link-underline link-underline-opacity-0 text-decoration-none"
                  to="https://www.google.com/maps/place/Rapid+Lab+and+Diagnostics+center/@5.6747617,-0.0208036,21z/data=!4m6!3m5!1s0xfdf813ca0f57087:0xef5fd0638781ba41!8m2!3d5.6748397!4d-0.0208213!16s%2Fg%2F11t6hmrfy0?entry=ttu&g_ep=EgoyMDI2MDMyMi4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                >
                  <button
                    className="btn text-white d-flex align-items-center gap-2"
                    style={{
                      border: "2px solid white",
                      padding: "12px 24px",
                      borderRadius: "6px",
                      fontWeight: "500",
                    }}
                  >
                    LOCATION
                    <span style={{ fontSize: "18px" }}>
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-caret-right-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                      </svg>
                    </span>
                  </button>
                </Link>
              </div>
            </div>
            {/* part 2 */}
            <div className="row align-items-center g-4 py-5 mt-5">
              {/* Left Content */}
              <div className="col-lg-6">
                <h2 className="fw-bold text-primary-emphasis ">
                  Reasons for an HSG
                </h2>

                <div
                  className="my-3"
                  style={{
                    width: "200px",
                    height: "5px",
                    backgroundColor: "gold",
                    borderRadius: "5px",
                  }}
                ></div>
                <p className="text-primary-emphasis">
                  An HSG is typically performed to evaluate the shape and
                  structure of the uterus and fallopian tubes. It can help
                  identify blockages, abnormalities, or other issues that may be
                  affecting fertility or causing reproductive health concerns.
                </p>
                <p className="text-primary-emphasis">
                  <ul className="p-0 m-0 ">
                    <li className="list-unstyled  pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}An HSG can help diagnose issues such as blocked
                        fallopian tubes, uterine abnormalities (like fibroids or
                        polyps), and other structural problems that may be
                        affecting fertility.
                      </span>
                    </li>

                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        It is often recommended for women who are experiencing
                        infertility or recurrent miscarriages to help identify
                        potential causes and guide treatment options.
                      </span>
                    </li>
                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        An HSG can also be used to evaluate the uterus and
                        fallopian tubes after certain medical procedures or
                        surgeries to ensure proper healing and function.
                      </span>
                    </li>

                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        It can help guide treatment options for infertility,
                        such as determining whether procedures like in vitro
                        fertilization (IVF) or surgery may be necessary to
                        improve fertility outcomes.
                      </span>
                    </li>
                  </ul>
                </p>

                <p className="text-primary-emphasis">
                  If you have been recommended to undergo an HSG, contact us
                  today to schedule your appointment and experience the
                  difference in care and quality at Rapid Lab Diagnostics.
                </p>
              </div>

              {/* Right Images */}
              <div className="col-lg-6 text-center">
                <img
                  src="images/assets/for-hsg.jpg"
                  alt="rapidLabEnterance"
                  loading="lazy"
                  className="img-fluid rounded mb-3"
                  style={{
                    maxHeight: "500px",
                    objectFit: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>
            </div>
            {/* Reviews */}

            <div className="container text-center py-5 bg-muted    ">
              <ReviewPage />
              <div className="row align-items-center g-4 py-5 mt-5">
                <div className="col-lg-6 text-center">
                  <img
                    src="images/assets/ultraS.jpg"
                    alt="rapidLabEnterance"
                    loading="lazy"
                    className="img-fluid rounded mb-3"
                    style={{
                      maxHeight: "500px",
                      objectFit: "cover",
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </div>
                <div className="col-lg-6">
                  <h2 className="fw-bold text-primary-emphasis text-start ">
                    Choose accurate and reliable HSG services at Rapid Lab
                    Diagnostics for comprehensive reproductive health evaluation
                    and care
                  </h2>

                  <div
                    className="my-3 "
                    style={{
                      width: "200px",
                      height: "5px",
                      backgroundColor: "gold",
                      borderRadius: "5px",
                    }}
                  ></div>

                  <p className="text-primary-emphasis text-start">
                    Rapid Lab Diagnostics offers HSG services with
                    state-of-the-art imaging technology and experienced
                    healthcare professionals. Our comprehensive reproductive
                    health evaluation and care ensure accurate and reliable
                    results, helping you understand your reproductive health
                    better and guiding you towards the best treatment options.
                    Contact us today to schedule your HSG appointment and
                    experience the difference in care and quality.
                  </p>
                </div>
              </div>

              {/* F&Q */}
              <div>
                <p className="fs-3 text-primary-emphasis">
                  HSG Frequently Asked Questions
                  <div
                    className="my-1 m-auto"
                    style={{
                      width: "200px",
                      height: "5px",
                      backgroundColor: "gold",
                      borderRadius: "5px",
                    }}
                  ></div>
                </p>
              </div>
              {/* Accordion */}
              <div
                className="accordion  col-10  m-auto my-5"
                id="accordionFlushExample "
                style={{ borderTop: "4px solid #FFD700", borderRadius: "8px" }}
              >
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="true"
                      aria-controls="flush-collapseOne"
                      style={{ borderRadius: "8px" }}
                    >
                      What happens during an HSG?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseOne"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      During an HSG procedure, a contrast dye is gently injected
                      into the uterus through the cervix. This dye helps to
                      highlight the reproductive organs on X-ray images. As the
                      dye fills the uterus and fallopian tubes, a series of
                      X-ray images are taken to visualize the shape and
                      structure of these organs. The images can reveal any
                      blockages, abnormalities, or issues that may be affecting
                      fertility or causing other reproductive health concerns.
                      The entire procedure is typically quick and may cause some
                      mild discomfort, but our experienced healthcare
                      professionals will ensure your comfort and safety
                      throughout the process.
                    </div>
                  </div>
                </div>
                <div
                  className="accordion-item mt-3"
                  style={{
                    borderTop: "4px solid #FFD700",
                    borderRadius: "8px",
                  }}
                >
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwo"
                      style={{ borderRadius: "8px" }}
                    >
                      How should I prepare for an HSG?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwo"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      To prepare for an HSG, it is important to follow any
                      instructions provided by your healthcare provider.
                      Generally, you may be advised to schedule the HSG
                      procedure after your menstrual period has ended but before
                      ovulation occurs, which is typically between days 7 and 10
                      of your menstrual cycle. You may also be asked to avoid
                      sexual intercourse for a few days before the procedure and
                      to inform your healthcare provider of any allergies,
                      especially to iodine or contrast dye. It is also
                      recommended to arrange for someone to drive you home after
                      the procedure, as you may experience some discomfort or
                      cramping. Additionally, you may want to take an
                      over-the-counter pain reliever before the procedure to
                      help minimize any potential discomfort. Always consult
                      with your healthcare provider for specific instructions
                      based on your individual health needs.
                    </div>
                  </div>
                </div>
                <div
                  className="accordion-item mt-3"
                  style={{
                    borderTop: "4px solid #FFD700",
                    borderRadius: "8px",
                  }}
                >
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThree"
                      aria-expanded="false"
                      aria-controls="flush-collapseThree"
                      style={{ borderRadius: "8px" }}
                    >
                      Is an HSG safe?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseThree"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      Yes, HSG (Hysterosalpingography) is generally safe when
                      performed by a trained healthcare professional. It uses a
                      small amount of X-ray radiation, which is kept within safe
                      medical limits, and the procedure is quick, so exposure is
                      minimal. It is also non-surgical, meaning there are no
                      cuts or incisions, which reduces the risk of
                      complications. The procedure is commonly used and
                      well-established, and medical staff follow sterile
                      techniques to help prevent infection. Some people may
                      experience mild cramping or slight discomfort, and in rare
                      cases there can be infection or a reaction to the contrast
                      dye, but overall it is considered a safe and effective
                      diagnostic test.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default HsgServices;
